module.exports = __webpack_public_path__ + "static/media/tip-calculator.c97e75ad.png";